"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/OrgRels/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);



var _utils = require('web/screens/Signup/utils');
var _signupAttribution = require('web/services/signupAttribution');

var _OrgRow = require('./OrgRow'); var _OrgRow2 = _interopRequireDefault(_OrgRow);
var _NewOrgRow = require('./NewOrgRow'); var _NewOrgRow2 = _interopRequireDefault(_NewOrgRow);
var _reacthookform = require('react-hook-form');
var _org = require('shared/validation/org/org');
var _Form = require('web/components/Form');
var _AuthFrame = require('web/components/AuthFrame');
var _components = require('web/screens/Signup/components');













// "Lakeview Family Clinic" → "LF", for the card's tile.
const initials = (name) => name
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map(word => _optionalChain([word, 'access', _ => _[0], 'optionalAccess', _2 => _2.toUpperCase, 'call', _3 => _3()]))
  .join('')







// One organization, with its action on the card. A long name wraps inside it.
const MatchCard = ({ name, detail, action }) => (
  _react2.default.createElement('div', { className: "signup--org-match-card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}
    , _react2.default.createElement('span', { className: "signup--org-match-card--tile", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}},  initials(name) )
    , _react2.default.createElement('div', { className: "signup--org-match-card--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
      , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 50}},  name )
      , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 51}},  detail )
    )
    ,  action 
  )
)



// A cold signup revisiting the step (e.g. via Back) carries its prior choice in
// the preset rels: an existing-org selection means they chose to join, anything
// else means they were creating a new org.
const initialColdMode = (requestedOrgRels) =>
  requestedOrgRels.some(_utils.isExistingOrgRel) ? 'join' : 'create'

const getPresetOrgs = (requestedOrgRels) =>
  requestedOrgRels.map(r => ({
    title: r.Title,
    org: _utils.isExistingOrgRel.call(void 0, r)
      ? { OrgKey: r.SelectedKey, Name: r.SelectedName }
      : r.NewOrgName,
  }))

const getFormOrgs = (requestedOrgRels) => {
  const presetOrgs = getPresetOrgs(requestedOrgRels)
  return presetOrgs.length ? presetOrgs : [{ org: '', title: '' }]
}

const OrgRelsSection = ({
  requestedOrgRels,
  matchState,
  onRetryMatches,
  onBack,
  onSubmit,
  emailDomain,
  error,
}) => {
  const hasInvites = matchState.status === 'ready' && matchState.matches.Invites.length > 0
  const hasSuggestions = matchState.status === 'ready' && matchState.matches.DomainSuggestions.length > 0
  // Seed the form once; the serialized form doubles as the first preset guard
  // below, so it is computed here rather than on every render.
  const [{ orgs: initialOrgs, serialized: initialPreset }] = _react.useState.call(void 0, () => {
    const orgs = getFormOrgs(requestedOrgRels)
    return { orgs, serialized: JSON.stringify(orgs) }
  })
  const { control, reset, setValue, formState, handleSubmit, trigger, clearErrors } =
    _reacthookform.useForm({
      resolver: _org.orgListResolver,
      // Validate a field when it loses focus, then as it is edited to clear the
      // error: never while its first value is still being typed.
      mode: 'onTouched',
      defaultValues: { orgs: initialOrgs },
    })
  const { fields } = _reacthookform.useFieldArray.call(void 0, { control, name: 'orgs' })
  const { isValid, isSubmitting } = formState
  // Shown once they leave a field after typing, never while they type.
  const display = _useFieldErrorDisplay2.default.call(void 0, {
    'orgs.0.org': _optionalChain([formState, 'access', _4 => _4.errors, 'access', _5 => _5.orgs, 'optionalAccess', _6 => _6[0], 'optionalAccess', _7 => _7.org]),
    'orgs.0.title': _optionalChain([formState, 'access', _8 => _8.errors, 'access', _9 => _9.orgs, 'optionalAccess', _10 => _10[0], 'optionalAccess', _11 => _11.title]),
  })

  const [selectedMode, setSelectedMode] = _react.useState(() => initialColdMode(requestedOrgRels))
  const mode = hasInvites ? 'join' : selectedMode
  const [isMatchSubmitting, setIsMatchSubmitting] = _react.useState.call(void 0, false)
  // Invited signups see their invitations alone (as drawn); searching for
  // another team as well stays one tap away.
  const [isSearchingWithInvites, setIsSearchingWithInvites] = _react.useState.call(void 0, false)
  const showRows = !hasInvites || isSearchingWithInvites

  // Tracks the last preset content we reset the form to. Guards against
  // resetting when only the array *identity* changes but the content does
  // not: reset() clears formState (including isSubmitting), which would
  // re-enable Continue mid-submit and let rapid clicks fire duplicate
  // POSTs (TM-372).
  const lastPresetRef = _react.useRef(initialPreset)

  _react.useEffect.call(void 0, 
    () => {
      const nextOrgs = getFormOrgs(requestedOrgRels)
      const serialized = JSON.stringify(nextOrgs)
      if (lastPresetRef.current === serialized) return

      lastPresetRef.current = serialized
      reset({ orgs: nextOrgs })
    },
    [reset, requestedOrgRels],
  )

  // Switching modes must clear the row's org value: a LookupOrg object must not
  // leak into create mode, nor a stale typed name linger as a phantom new-org.
  // The duplicate-org guard is the exception — it seeds the search with the
  // typed name so the user sees their org immediately.
  const switchToJoin = (typedName = '') => {
    setSelectedMode('join')
    setValue('orgs.0.org', typedName, { shouldTouch: false })
    clearErrors('orgs.0.org')
  }

  const switchToCreate = () => {
    setSelectedMode('create')
    setValue('orgs.0.org', '', { shouldTouch: false })
    clearErrors('orgs.0.org')
  }

  const submit = (data, e) => {
    _optionalChain([e, 'optionalAccess', _12 => _12.preventDefault, 'call', _13 => _13()])
    const chosenRels = data.orgs
      .map(rel => ({
        Title: rel.title,
        ...(typeof rel.org === 'string'
          ? { NewOrgName: rel.org }
          : {
              SelectedKey: rel.org.OrgKey ,
              SelectedName: rel.org.Name,
            }
        ),
      }))

    // The parent persists submitted rels so a later remount can restore them.
    // Mark that content as already preset before the parent update arrives:
    // reset() during this submit would clear isSubmitting and re-enable Continue.
    const inviteRels = matchState.status === 'ready'
      ? toInviteRels(matchState.matches)
      : []
    const inviteKeys = new Set(inviteRels.map(rel => rel.SelectedKey))
    const hasExistingChoice = chosenRels.some(_utils.isExistingOrgRel)
    const rels = hasExistingChoice
      ? [
          ...inviteRels,
          ...chosenRels.filter(rel => !_utils.isExistingOrgRel.call(void 0, rel) || !inviteKeys.has(rel.SelectedKey)),
        ]
      : chosenRels
    lastPresetRef.current = JSON.stringify(getPresetOrgs(rels))
    const searchedRels = chosenRels.filter(_utils.isExistingOrgRel)
    if (searchedRels.length) {
      _signupAttribution.captureSignupEvent.call(void 0, 'signup organization match selected', {
        match_kind: 'search',
        organization_ids: searchedRels.map(rel => rel.SelectedKey),
        invite_count: inviteRels.length,
        surface: 'organization_search',
      })
    }
    return onSubmit(rels)
  }

  const renderRows = () => {
    // The single cold row only exists once `reset` has seeded the field array;
    // rendering before that would hand OrgPicker an undefined value.
    if (!fields.length) return null

    // Cold signups create a new org by default; join is behind an explicit
    // choice. Either way the single row is always editable.
    return mode === 'create'
      ? (
          _react2.default.createElement(_NewOrgRow2.default, {
            idx: 0,
            control: control,
            display: display,
            onSwitchToJoin: switchToJoin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}}
          )
        )
      : (
          _react2.default.createElement(_OrgRow2.default, {
            idx: 0,
            control: control,
            trigger: trigger,
            display: display,
            canEditOrg: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}
          )
        )
  }

  const submitMatch = (
    matches,
    rels,
    kind,
    organizationIds,
  ) => {
    if (isMatchSubmitting) return
    setIsMatchSubmitting(true)
    _signupAttribution.captureSignupEvent.call(void 0, 'signup organization match selected', {
      match_kind: kind,
      organization_ids: organizationIds,
      invite_count: matches.Invites.length,
      surface: 'organization_step',
    })
    // The parent's onSubmit already reports failures; here we only need to
    // re-enable the cards once it settles either way.
    const done = () => setIsMatchSubmitting(false)
    const result = onSubmit(rels)
    if (result instanceof Promise) result.then(done, done)
    else done()
  }

  const renderMatches = () => {
    if (matchState.status === 'loading') {
      return (
        _react2.default.createElement('div', { className: "signup--org-match-status", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 248}}, "Checking for invitations…"  )
          , _react2.default.createElement('span', { className: "signup--org-match-skeleton", __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}} )
          , _react2.default.createElement('span', { className: "signup--org-match-skeleton", __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}} )
        )
      )
    }
    if (matchState.status === 'failed') {
      return (
        _react2.default.createElement(_AuthFrame.Callout, {
          message: "We couldn't check for invitations."    ,
          detail: "Check your connection, then try again. Nothing you entered is lost."          ,
          actions: (
            _react2.default.createElement('button', { type: "button", className: "auth-chip", onClick: onRetryMatches, __self: this, __source: {fileName: _jsxFileName, lineNumber: 260}}, "Try again"

            )
          ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}
        )
      )
    }

    const { matches } = matchState
    if (!matches.Invites.length && !matches.DomainSuggestions.length) return null
    const inviteRels = toInviteRels(matches)
    return (
      _react2.default.createElement('div', { className: "signup--org-matches", __self: this, __source: {fileName: _jsxFileName, lineNumber: 272}}
        ,  matches.Invites.length > 0 && (
          _react2.default.createElement('section', { 'aria-labelledby': "signup-invitations-heading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}
            , _react2.default.createElement('h2', { id: "signup-invitations-heading", className: "signup--org-section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}, "Your invitations" )
            ,  matches.Invites.map(invite => (
              _react2.default.createElement(MatchCard, {
                key: invite.OrgKey,
                name: invite.Name,
                detail: invite.Title ? _react2.default.createElement(_react2.default.Fragment, null, "You're invited · Role: "    , invite.Title) : "You're invited",
                action: (
                  _react2.default.createElement(_Form.Button, {
                    ariaLabel: `Join ${invite.Name}`,
                    isDisabled: isMatchSubmitting,
                    isLoading: isMatchSubmitting,
                    onClick: () => submitMatch(matches, inviteRels, 'invite', matches.Invites.map(item => item.OrgKey)), __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}
, "Join"

                  )
                ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}
              )
            )) 
            , _react2.default.createElement('p', { className: "signup--org-match-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 293}}, "Joining accepts every invitation listed for this account."       )
          )
        ) 
        ,  matches.DomainSuggestions.length > 0 && (
          _react2.default.createElement('section', { 'aria-labelledby': "signup-suggestions-heading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 297}}
            , _react2.default.createElement('h2', { id: "signup-suggestions-heading", className: "signup--org-section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 298}}
              ,  emailDomain ? `Organizations using @${emailDomain}` : 'Organizations using your work email domain' 
            )
            ,  matches.DomainSuggestions.map(suggestion => {
              const rels = [
                ...inviteRels,
                { Title: '', SelectedKey: suggestion.OrgKey, SelectedName: suggestion.Name },
              ]
              return (
                _react2.default.createElement(MatchCard, {
                  key: suggestion.OrgKey,
                  name: suggestion.Name,
                  detail: "An administrator will review your request."     ,
                  action: (
                    _react2.default.createElement(_Form.Button, {
                      ariaLabel: `Request to join ${suggestion.Name}`,
                      isSecondary: true,
                      isDisabled: isMatchSubmitting,
                      isLoading: isMatchSubmitting,
                      onClick: () => submitMatch(matches, rels, 'domain', [suggestion.OrgKey]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 312}}
, "Request to join"

                    )
                  ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 307}}
                )
              )
            }) 
            ,  !hasInvites && _react2.default.createElement('p', { className: "signup--org-or", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}}, "or create a new one"    ) 
          )
        ) 
      )
    )
  }

  const header = () => {
    if (matchState.status !== 'ready') {
      return { title: 'Your organization', subtitle: undefined }
    }
    if (hasInvites) {
      return { title: 'Join your team', subtitle: 'You have an invitation waiting.' }
    }
    return mode === 'create'
      ? { title: 'Create your organization', subtitle: "Let's assign you to an organization." }
      : { title: 'Join an existing organization', subtitle: 'Search for your team and request to join.' }
  }

  return (
    _react2.default.createElement('form', { onSubmit: handleSubmit(submit, () => display.onSubmitErrors(['orgs.0.org', 'orgs.0.title'])), __self: this, __source: {fileName: _jsxFileName, lineNumber: 345}}
      , _react2.default.createElement(_components.SignupStepHeader, { ...header(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 346}} )
      ,  renderMatches() 
      ,  matchState.status === 'ready' && showRows && renderRows() 
      ,  matchState.status === 'ready' && (
        _react2.default.createElement('div', { className: "signup--org-mode-toggle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 350}}
          ,  mode === 'create'
            ? (
                _react2.default.createElement('button', { type: "button", className: "auth-link", onClick: () => switchToJoin(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 353}}
                  ,  hasSuggestions
                    ? "Joining a team that isn't listed here? Search for it."
                    : 'Joining an existing team? Request to join.' 
                )
              )
            : !hasInvites
                ? (
                    _react2.default.createElement('button', { type: "button", className: "auth-link", onClick: switchToCreate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 361}}, "Create a new organization instead"

                    )
                  )
                : !isSearchingWithInvites && (
                    _react2.default.createElement('button', { type: "button", className: "auth-link", onClick: () => setIsSearchingWithInvites(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 366}}, "Joining another team too? Search for it."

                    )
                  )
          
        )
      )
      ,  error && _react2.default.createElement(_AuthFrame.Callout, { message: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 373}} ) 
      , _react2.default.createElement(_components.SignupStepControls, {
        onBack: onBack,
        isNextDisabled: matchState.status !== 'ready' || !isValid || isSubmitting || isMatchSubmitting,
        isNextLoading: isSubmitting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 374}}
      )
    )
  )
}

const toInviteRels = (matches) =>
  matches.Invites.map(invite => ({
    Title: invite.Title,
    SelectedKey: invite.OrgKey,
    SelectedName: invite.Name,
    IsInvite: true,
  }))

exports. default = OrgRelsSection
